<template>
  <div class="kl-update-password-page">
    <div class="container-update-password">
      <div class="update-password-box">
        <div class="update-password-box__header">
          <h2 class="update-password-box__title">Modifique su contraseña</h2>
        </div>

        <b-form-group
          id="input-group-current_password"
          label="Contraseña actual"
          label-for="input-current_password"
        >
          <div class="d-flex password-field">
            <b-form-input
              id="input-current_password"
              class="m-0"
              :type="!current_password_visibility ? 'password' : 'text'"
              placeholder="Contraseña actual"
              @keyup.enter="changePassword"
              v-model="$v.user_password.current_password.$model"
              :state="validateState('current_password')"
              aria-describedby="input-current_password-name-feedback"
            ></b-form-input>
            <b-button
              class="password-visibility"
              :title="
                current_password_visibility
                  ? 'Ocultar contraseña'
                  : 'Mostrar contraseña'
              "
              @click="
                () =>
                  (current_password_visibility = !current_password_visibility)
              "
              ><b-icon v-if="current_password_visibility" icon="eye"></b-icon
              ><b-icon v-else icon="eye-slash"></b-icon
            ></b-button>
          </div>
          <b-form-invalid-feedback
            id="input-current_password-name-feedback"
            :state="validateState('current_password')"
            >Este campo es obligatorio.</b-form-invalid-feedback
          >
        </b-form-group>

        <b-form-group
          id="input-group-password"
          label="Nueva contraseña"
          label-for="input-password"
        >
          <div class="d-flex password-field">
            <b-form-input
              id="input-password"
              class="m-0"
              v-model="$v.user_password.password.$model"
              :type="!new_password_visibility ? 'password' : 'text'"
              :state="validateState('password')"
              placeholder="Nueva contraseña"
              @keyup.enter="changePassword"
              aria-describedby="input-password-name-feedback"
            ></b-form-input>
            <b-button
              class="password-visibility"
              :title="
                new_password_visibility
                  ? 'Ocultar contraseña'
                  : 'Mostrar contraseña'
              "
              @click="
                () => (new_password_visibility = !new_password_visibility)
              "
              ><b-icon v-if="new_password_visibility" icon="eye"></b-icon
              ><b-icon v-else icon="eye-slash"></b-icon
            ></b-button>
          </div>
          <b-form-invalid-feedback
            id="input-password-name-feedback"
            :state="validateState('password')"
            ><div class="d-block text-left">
              La contraseña de estar compuesta al menos por:
              <div v-if="!/[a-z]/.test(user_password.password)" class="ml-4">
                - Al menos una letra en minúsculas.
              </div>
              <div v-if="!/[A-Z]/.test(user_password.password)" class="ml-4">
                - Al menos una letra en mayúsculas.
              </div>
              <div v-if="!/[0-9]/.test(user_password.password)" class="ml-4">
                - Al menos un número.
              </div>
              <div
                v-if="!/[.#?!@$%^&*-]/.test(user_password.password)"
                class="ml-4"
              >
                - Al menos un simbolo.
              </div>
              <div
                v-if="
                  $v.user_password.password.$params.minLength.min >
                  user_password.password.length
                "
                class="ml-4"
              >
                - Debe tener
                {{ $v.user_password.password.$params.minLength.min }}
                carácteres como mínimo.
              </div>
            </div></b-form-invalid-feedback
          >
        </b-form-group>

        <b-form-group
          id="input-group-confirm_password"
          label="Confirmar contraseña"
          label-for="input-confirm_password"
        >
          <div class="d-flex password-field">
            <b-form-input
              id="input-confirm_password"
              class="m-0"
              :type="!confirm_password_visibility ? 'password' : 'text'"
              v-model="$v.user_password.confirm_password.$model"
              :state="validateState('confirm_password')"
              placeholder="Confirmar contraseña"
              @keyup.enter="changePassword"
              aria-describedby="input-confirm_password-name-feedback"
            ></b-form-input>
            <b-button
              class="password-visibility"
              :title="
                confirm_password_visibility
                  ? 'Ocultar contraseña'
                  : 'Mostrar contraseña'
              "
              @click="
                () =>
                  (confirm_password_visibility = !confirm_password_visibility)
              "
              ><b-icon v-if="confirm_password_visibility" icon="eye"></b-icon
              ><b-icon v-else icon="eye-slash"></b-icon
            ></b-button>
          </div>
          <b-form-invalid-feedback
            id="input-confirm_password-name-feedback"
            :state="validateState('confirm_password')"
            >Las contraseñas no son iguales.</b-form-invalid-feedback
          >
        </b-form-group>

        <b-button @click="changePassword" variant="primary"
          >Cambiar contraseña</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { toast } from "@/utils/utils";
import { mapGetters } from "vuex";
import { required, minLength, sameAs } from "vuelidate/lib/validators";
export default {
  name: "UpdatePassword",
  mixins: [validationMixin],

  data() {
    return {
      user_password: {
        current_password: "",
        password: "",
        confirm_password: "",
      },
      current_password_visibility: false,
      new_password_visibility: false,
      confirm_password_visibility: false,
    };
  },
  validations: {
    user_password: {
      current_password: {
        required,
      },
      password: {
        required,
        minLength: minLength(8),
        containsUppercase: function (value) {
          return /[A-Z]/.test(value);
        },
        containsLowercase: function (value) {
          return /[a-z]/.test(value);
        },
        containsNumber: function (value) {
          return /[0-9]/.test(value);
        },
        containsSpecial: function (value) {
          return /[.#?!@$%^&*-]/.test(value);
        },
      },
      confirm_password: { required, sameAsPassword: sameAs("password") },
    },
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.user_password[name];
      return $dirty ? !$error : null;
    },
    changePassword() {
      this.$v.user_password.$touch();
      if (this.$v.user_password.$anyError) {
        return;
      }
      const payload = {
        old_password: this.user_password.current_password,
        new_password: this.user_password.password,
        repeated_password: this.user_password.confirm_password,
      };
      this.$restful
        .Put(`/authentication/password/`, payload)
        .then((response) => {
          if (response) {
            this.user.has_changed_password = true;
            this.$store.commit("setUser", this.user);
            toast("Contraseña actualizada con éxito.");
          }
        })
        .catch(() => {
          return this.$swal({
            text: "La contraseña actual es incorrecta.",
            type: "warning",
          });
        });
    },
  },
  created() {},
};
</script>

<style scoped>
.kl-update-password-page {
  /* Migrado al sistema global de tokens (utils/styles_kl.css). */
  --kl-blue: var(--kl-color-primary);
  --kl-blue-dark: var(--kl-color-primary-deep);
  --kl-teal: var(--kl-color-secondary);
  --kl-ink: var(--kl-text-heading);
  --kl-text: var(--kl-text-body);
  --kl-border: var(--kl-border-soft);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 20px;
  background: linear-gradient(
    135deg,
    var(--kl-blue-dark) 0%,
    var(--kl-blue) 55%,
    var(--kl-teal) 130%
  );
}
.container-update-password {
  position: relative;
  margin: auto;
  width: 100%;
}
.update-password-box {
  margin-left: auto;
  margin-right: auto;
  background-color: var(--kl-surface);
  padding: 52px 52px;
  border-radius: 24px;
  box-shadow: 0 30px 70px rgba(0, 0, 0, 0.28);
  max-width: 560px;
  width: 100%;
}
.update-password-box__header {
  text-align: center;
  margin-bottom: 30px;
}
.update-password-box__title {
  font-weight: var(--kl-fw-bold);
  font-size: var(--kl-fs-title-md);
  margin: 0;
  color: var(--kl-ink);
  letter-spacing: -0.01em;
}

/* Inputs */
.update-password-box ::v-deep label {
  font-weight: var(--kl-fw-semibold);
  color: var(--kl-text);
  margin-bottom: 6px;
}
.update-password-box ::v-deep .form-control {
  height: 48px;
  border: 1.5px solid rgba(0, 110, 200, 0.35);
  border-radius: var(--kl-radius-lg);
  background-color: #f5f9fd;
  color: var(--kl-ink);
  transition: border-color 0.25s ease, box-shadow 0.25s ease,
    background-color 0.25s ease;
}
.update-password-box ::v-deep .form-control:focus {
  border-color: var(--kl-blue);
  background-color: #ffffff;
  box-shadow: 0 0 0 3px rgba(0, 110, 200, 0.15);
}

/* Campo de contraseña + botón mostrar/ocultar uniformes */
.password-field {
  align-items: stretch;
}
.password-field ::v-deep .form-control {
  flex: 1;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: none;
}
.password-field ::v-deep .form-control.is-invalid,
.password-field ::v-deep .form-control.is-valid {
  background-image: none;
  padding-right: 0.75rem;
}
.password-visibility {
  height: 48px;
  width: 50px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid rgba(0, 110, 200, 0.35);
  border-left: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: var(--kl-radius-lg);
  border-bottom-right-radius: var(--kl-radius-lg);
  background-color: #f5f9fd;
  color: #8a97a5;
  box-shadow: none;
}
.password-visibility svg {
  color: #8a97a5;
  fill: currentColor;
}
.password-visibility:hover {
  background-color: #eaf3fb;
  color: var(--kl-blue);
  transform: none;
}
.password-visibility:hover svg {
  color: var(--kl-blue);
}
.password-visibility:focus,
.password-visibility:active {
  background-color: #eaf3fb;
  box-shadow: none;
}

/* Botón principal */
.update-password-box ::v-deep .btn-primary {
  width: 100%;
  height: 52px;
  margin-top: 8px;
  border: none;
  border-radius: 14px;
  font-weight: var(--kl-fw-bold);
  font-size: var(--kl-fs-small);
  letter-spacing: 0.06em;
  text-transform: uppercase;
  background: linear-gradient(135deg, var(--kl-blue) 0%, var(--kl-teal) 100%);
  box-shadow: 0 10px 24px rgba(0, 110, 200, 0.3);
  transition: transform 0.25s ease, box-shadow 0.25s ease, filter 0.25s ease;
}
.update-password-box ::v-deep .btn-primary:hover {
  transform: translateY(-2px);
  filter: brightness(1.05);
  box-shadow: 0 14px 30px rgba(0, 110, 200, 0.38);
}
</style>